import { NgModule } from '@angular/core';
import { Store, StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { EffectsModule } from '@ngrx/effects';

import { reducers, effects, metaReducers } from './store';
import { CustomStore } from './store/services/custom-store.service';

@NgModule({
  imports: [
    StoreModule.forRoot(reducers, { metaReducers }),
    EffectsModule.forRoot(effects),
    StoreDevtoolsModule.instrument({
      maxAge: 100,
    }),
  ],
  providers: [
    { provide: Store, useClass: CustomStore }
  ],
})
export class BlocksStateModule { }

